import React, { memo } from 'react';
import Avatar from 'Modules/Avatar/Avatar';
import DoctorAvatar from 'Assets/images/commons/default-doctor.png';
import { Icon } from 'semantic-ui-react';
import { func, shape, bool } from 'prop-types';
import classnames from 'classnames';
import Dialog from 'Modules/Dialog/Dialog';
import { INVITATION_ACCEPT } from 'Constants/consults';

import styles from './DoctorItem.less';

const DoctorItem = ({ item, isActive, onClickItem }) => {
  const {
    name,
    title,
    avatar,
    invitation,
    existActiveConsult,
  } = item;

  const isInvited = invitation?.toDoctorStatus === INVITATION_ACCEPT || invitation?.toDoctorStatus === null;

  const clickItem = () => {
    if (existActiveConsult) {
      Dialog.info({
        title: 'Existing Active Consult',
        content: 'You have existing active consult with this patient.',
      });
    } else if (isInvited) {
      Dialog.info({
        title: 'Invited Doctor',
        content: 'You have already invited this doctor.',
      });
    } else {
      onClickItem(item, isActive);
    }
  };

  const classContainer = classnames(
    `${styles.container}`,
    { [styles.active]: isActive },
    { [styles.existActive]: existActiveConsult },
  );

  return (
    <div className={classContainer} onClick={clickItem}>
      <div className={styles.avatar}>
        <Avatar avatar={avatar?.originalPath || DoctorAvatar} />
      </div>
      <div className={styles.content}>
        <div>
          <div className={styles.name}>{name}</div>
          <div className={styles.title}>{title}</div>
        </div>
        {
          (isActive || isInvited)
          && (
            <div className={styles.check}>
              <Icon name="checkmark" color={isInvited ? 'grey' : 'blue'} size="large" />
            </div>
          )
        }
      </div>

    </div>
  );
};

DoctorItem.propTypes = {
  isActive: bool,
  item: shape({}).isRequired,
  onClickItem: func.isRequired,
};

DoctorItem.defaultProps = {
  isActive: false,
};


export default memo(DoctorItem);
